<template>
  <Login>
    <template v-slot:title>
      <span id="loginTitle">{{ $t("ForgotPassword") }}</span>
      <span id="loginMessage">{{ $t("PasswordMessage") }}</span>
    </template>
    <template v-slot:form>
      <form class="loginForm" @submit.prevent="submit">
        <div class="main-login-form-container">
          <div class="email-div">
            <span class="login-input-label">{{ $t('Email') }}</span>
            <input
              v-model="email"
              ref="email"
              type="email"
              name="email"
              class="loginInput userInput effect-7"
              spellcheck="false"
              @keyup.enter="recoverySubmit"
            />
          </div>
        </div>
      </form>
    </template>
    <template v-slot:button>
      <v-btn
        type="submit"
        color="accent--text"
        @click="recoverySubmit"
        class="signInInput"
        outlined
        :disabled="!email"
      >
        {{ $t("Send") }}
      </v-btn>
    </template>
    <template v-slot:remember-me-reset-password>
      <div class="field-success-div">
        <span class="field-success-div-span" v-if="emailSent">
          {{ $t("EmailSentSuccess") }}
        </span>
      </div>
    </template>
  </Login>
</template>

<script>
import _ from "lodash";
import Login from "@/views/Login";
import { mapActions } from "vuex";

export default {
  name: "LoginRecoveryEmail",

  components: { Login },

  data() {
    return {
      /**
       * Stores the email adress
       */
      email: "",
      emailSent: null,
    };
  },
  beforeDestroy() {
    window.removeEventListener("keyup", this._keyListener);
  },
  methods: {
    ...mapActions(["SEND_RECOVERY_EMAIL"]),

    recoverySubmit() {
      this.SEND_RECOVERY_EMAIL(this.email);
      this.emailSent = true
      this.email = ""
    },

    backButtonHandler() {
        this.$router.back()
    }
  },
};
</script>
<style scoped>

.backButton {
  color: white !important;
  width: 60px;
  height: 60px;
  position: absolute;
  left: -90px;
}

.titleSpan {
  color: white;
  font-size: 20px;
  text-transform: uppercase;
}

.headerContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
}

.field-success-div-span {
  display: flex;
  color: #231E46;
  margin-top: 86px;
}

.field-success-div {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Login/LoginRecoveryEmail.vue